<div class="mydocma-mm-attribute-dropdown-tile">
  <img [src]="imageUrl" class="attribute-image" [alt]="item?.data?.data?.ImageFileName">
  <p>{{item.text}}</p>
</div>
